@import '@hevoio/hevo-ui-toolkit/styles/variables';

$container-width: 1150px;

.backButton {
  position: absolute !important;
  top: $spacer-24;
  left: calc((100% - #{$container-width}) / 2);
}

.selectDefaultNodeWrapper {
  margin-left: 94px;
}

.tilesContainer {
  padding-bottom: 65px;
  margin-top: $spacer-32;
}
